var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 322,
    height: 326,
    viewBox: "0 0 322 326",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1596_20813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321.25 194C321.25 300.729 234.729 387.25 128 387.25C21.271 387.25 -65.25 300.729 -65.25 194C-65.25 87.271 21.271 0.75 128 0.75C234.729 0.75 321.25 87.271 321.25 194Z",
    stroke: "url(#paint0_linear_1596_20813)",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9506 172.428L112.242 123.414H112.271L112.488 123.039C119.456 110.966 136.89 110.966 143.858 123.039L144.507 122.664L143.858 123.039L172.365 172.428L200.873 221.816C207.841 233.889 199.123 248.992 185.188 248.992H128.158H71.1279C57.1772 248.992 48.4608 233.889 55.4427 221.817L55.443 221.816L83.9506 172.428Z",
    stroke: "url(#paint1_linear_1596_20813)",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1596_20813",
    x1: 128,
    y1: 0,
    x2: 128,
    y2: 388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2CA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1596_20813",
    x1: 128.154,
    y1: 113.234,
    x2: 128.154,
    y2: 249.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2CA6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1596_20813"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 388,
    height: 388,
    fill: "white",
    transform: "translate(-66)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/loginLogo.85910f2c73dd36ebd118a2659d07eeb5.svg";
export { ForwardRef as ReactComponent };